import CollectionAPI from 'api/Collection';
import actions, { MODAL_TYPES } from 'state/constants';
import Log from 'utils/Log';

export const fetchMasterProduct = handle => async dispatch => {
  dispatch({ type: actions.FETCH_MASTER_PRODUCT_REQUEST, payload: { handle } });

  try {
    const data = await CollectionAPI.fetchMasterProduct(handle);

    dispatch({ type: actions.FETCH_MASTER_PRODUCT_SUCCESS, payload: { handle, data } });
  } catch (error) {
    Log.error(error, `Fetching Master Product "${handle}" Failed.`);
    dispatch({
      type: actions.FETCH_MASTER_PRODUCT_FAILURE,
      payload: { handle, error: error.message },
    });
  }
};

export const setPdpZoomViewGridIndex = index => dispatch => {
  dispatch({ type: actions.SET_CURRENT_MAIN_CAROUSEL_SLIDE, payload: index });
  dispatch({
    type: actions.OPEN_MODAL,
    payload: MODAL_TYPES.PDP_ZOOM_VIEW,
    meta: { origination: undefined },
  });
};

export const setCurrentMainCarouselSlide = index => dispatch => {
  dispatch({ type: actions.SET_CURRENT_MAIN_CAROUSEL_SLIDE, payload: index });
};

export const setCurrentThumbnailCarouselSlide = index => dispatch => {
  dispatch({ type: actions.SET_CURRENT_THUMBNAIL_CAROUSEL_SLIDE, payload: index });
};

export const setProductData = handle => dispatch => {
  dispatch({ type: actions.SET_PRODUCT_DATA, payload: handle });
};

export const setCurrentProduct = handle => dispatch => {
  dispatch({ type: actions.SET_CURRENT_PRODUCT, payload: handle });
};

export const setInitialProduct = handle => dispatch => {
  dispatch({ type: actions.SET_INITIAL_PRODUCT, payload: handle });
};

export const setCurrentAttributeIndex = (index, origination) => dispatch => {
  dispatch({ type: actions.SET_CURRENT_ATTRIBUTE_INDEX, payload: index, meta: { origination } });
};

export const setCurrentSize = size => dispatch => {
  dispatch({ type: actions.SET_CURRENT_SIZE, payload: size });
};

export const setPdpVideoModalUrl = url => dispatch => {
  dispatch({ type: actions.SET_PDP_VIDEO_MODAL_URL, payload: url });
};

export const setAdditonalPdpModuleData = modules => dispatch => {
  dispatch({ type: actions.SET_PDP_MODULE_DATA, payload: { modules } });
};

export const trackProductUpdatesTooltipView = () => dispatch => {
  dispatch({ type: actions.TRACK_PRODUCT_UPDATES_TOOLTIP_VIEW });
};

export const trackPdpProductSelectorCarouselScroll = () => dispatch => {
  dispatch({ type: actions.TRACK_PDP_PRODUCT_SELECTOR_CAROUSEL_SCROLL });
};

export const trackPdpViewDifferentiatorsClick = () => dispatch => {
  dispatch({ type: actions.TRACK_VIEW_DIFFERENTIATORS_CLICK });
};

export const trackPdpCloseAddToCartModal = (closeType, closeLocation) => dispatch => {
  dispatch({ type: actions.TRACK_CLOSE_ADD_TO_CART_MODAL, payload: { closeType, closeLocation } });
};

export const trackPdpStoreInventoryDropdownAction = (type, name, copy) => dispatch => {
  dispatch({ type: actions.TRACK_STORE_INVENTORY_DROPDOWN_ACTION, payload: { type, name, copy } });
};

export const trackPdpStoreInventoryModalAction = (type, name, copy) => dispatch => {
  dispatch({ type: actions.TRACK_STORE_INVENTORY_MODAL_ACTION, payload: { type, name, copy } });
};

export const selectQuantity = quantity => dispatch => {
  dispatch({ type: actions.SELECT_QUANTITY, payload: { quantity } });
};
